import { Inject, ModuleWithProviders, NgModule } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { FormControlPipe } from './pipes'
import { NgxSpinnerModule } from 'ngx-spinner'
import { ToastrModule } from 'ngx-toastr'
import { QrCodeDisplayComponent } from './components'
import { QRCodeModule } from 'angularx-qrcode'
import { MaterialModule } from './modules/material.module'
import { QrCodeUtilsService } from './services/qr-code-utils.service'
import { SbsEnvironment } from './models/sbs-environment'
import { ActionApp } from '../../generated/common/graphql'
import { ACTION_APP, SBS_ENVIRONMENT, SbsCommonModule } from '../sbs-common.module'
import { FlagDisplayerComponent } from './components/flag-displayer/flag-displayer.component'

export const components = [QrCodeDisplayComponent, FormControlPipe, FlagDisplayerComponent]

@NgModule({
  declarations: [...components],
  imports: [CommonModule, NgxSpinnerModule, ToastrModule.forRoot(), QRCodeModule, MaterialModule],
  providers: [DatePipe],
  exports: [...components],
})
export class SbsSharedModule {}
